.root {
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;

  border-radius: 6px;

  button {
    gap: 10px;
  }

  span {
    line-height: 139%; /* 19.46px */
    letter-spacing: 0.14px;
  }
}
